import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "bootstrap/dist/css/bootstrap.css";
import { RouterProvider } from "react-router-dom";
import { router } from "./Routes/Routes.tsx";

import global_en from "./translations/en/global.json";
import global_es from "./translations/es/global.json";
import global_cat from "./translations/cat/global.json";

import i18next from "i18next";
import { I18nextProvider } from "react-i18next";
i18next.init({
    interpolation: { escapeValue: true },
    lng: "en",
    resources: {
        en: {
            global: global_en,
        },
        es: {
            global: global_es,
        },
        cat: {
            global: global_cat,
        },
    },
});
ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
        <I18nextProvider i18n={i18next}>
            <RouterProvider router={router} />
        </I18nextProvider>
    </React.StrictMode>
);
